import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Tutorial } from '../api/interfaces/tutorial.interface';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-tutorial-video-dialog',
  styleUrls: ['./tutorial-video-dialog.component.scss'],
  template: `
    <!-- Dialog Header -->
    <div class="w-100 d-flex justify-content-between align-items-center dialog-header">
      <h2 class="align-items-center d-flex m-0 p-0">
        <i [ngClass]="getServicePlanIcon(data.tutorial)"></i>
        {{ data.tutorial.name }}
      </h2>
      <span class="icon-smap-action-close close-button" (click)="close()" [matTooltip]="'SHARE_DIALOG.CLOSE_TOOLTIP' | translate"></span>
    </div>
    <div mat-dialog-content>
      <div class="video-wrapper">
        <iframe
          [src]="videoUrl"
          width="100%"
          height="100%"
          frameborder="0"
          allowfullscreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          class="video-iframe">
        </iframe>
      </div>
    </div>
  `,
  standalone: true,
  imports: [
    CommonModule,
    MatDialogContent,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogActions,
    TranslatePipe
  ]
})
export class TutorialVideoDialogComponent implements OnInit {
  videoUrl: SafeResourceUrl | null = null;

  constructor(
    public dialogRef: MatDialogRef<TutorialVideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { tutorial: Tutorial },
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.processVideoUrl();
  }


  private processVideoUrl() {
    let url = this.data.tutorial.source;

    // Convert YouTube watch URLs to embed URLs
    if (url.includes('youtube.com/watch')) {
      const videoId = url.split('v=')[1]?.split('&')[0];
      if (videoId) {
        url = `https://www.youtube.com/embed/${videoId}`;
      }
    } else if (url.includes('youtu.be/')) {
      const videoId = url.split('youtu.be/')[1]?.split('?')[0];
      if (videoId) {
        url = `https://www.youtube.com/embed/${videoId}`;
      }
    }

    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getServicePlanIcon(tutorial: Tutorial): string {
    // Map service plan IDs to icons
    switch (tutorial.minServicePlanId.toLowerCase()) {
      case 'free':
        return 'icon-smap-plan-free';
      case 'creator':
        return 'icon-smap-plan-creator';
      case 'publisher':
        return 'icon-smap-plan-publisher';
      case 'developer':
        return 'icon-smap-plan-developer';
      default:
        return 'icon-smap-plan-free';
    }
  }

  close() {
    this.dialogRef.close();
  }
}
